<template>
    <div id="app">
        <index-main></index-main>
    </div>
</template>

<script>
    // [Do not delete] initialization file
    import indexMain from './components/pages/index-main.vue'

    export default {
        name: 'app',
        metaInfo: {
            title: 'Lunar Base - Base building strategy card game',
        },
        components: {
            indexMain
        },
    }
</script>
